<template>
  <ButtonGroup color="grey">
    <PopoverMenu v-model:open="open" placement="bottom-start" auto-hide data-test-id="sort-overlay">
      <template #trigger>
        <Btn color="grey" data-test-id="sort-button">
          {{ buttonLabel }}
        </Btn>
      </template>

      <template #items-list>
        <PopoverMenuSection>
          <PopoverMenuSelectionList
            :options="listOptions"
            :modelValue="modelValue[0]"
            @update:modelValue="onSortPropChange"
          />
        </PopoverMenuSection>
      </template>
    </PopoverMenu>

    <Btn
      @click="$emit('update:modelValue', [modelValue[0], modelValue[1] === 1 ? -1 : 1, modelValue[2]])"
      color="grey"
      icon
      data-test-id="sort-direction-toggle"
    >
      <SortUpIcon16 v-if="modelValue[1] === 1" />
      <SortDownIcon16 v-else />
    </Btn>
  </ButtonGroup>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { find, propEq } from 'ramda';
import SortUpIcon16 from '@components/Icons/SortUpIcon16.vue';
import SortDownIcon16 from '@components/Icons/SortDownIcon16.vue';
import type { ListOptions } from './common/SelectionList.vue';

export default defineComponent({
  name: 'SortBar',
  emits: { 'update:modelValue': null },

  components: {
    SortUpIcon16,
    SortDownIcon16,
  },

  props: {
    modelValue: {
      required: true,
      type: Array,
    },

    options: {
      required: true,
      type: Array as PropType<Array<{ label: string; key: string; value: [string, string] }>>,
    },
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    onSortPropChange(value: string) {
      const selectedOption = this.options.find((option) => option.key === value);

      // Also emit sort direction
      this.$emit('update:modelValue', [selectedOption.value[0], this.modelValue[1], selectedOption.value[1]]);
    },
  },

  computed: {
    buttonLabel(): string {
      return `${this.$t('action.sortBy')} ${this.label}`;
    },

    label(): string {
      return find(propEq('value', [this.modelValue[0], this.modelValue[2]]), this.options).label;
    },

    listOptions(): ListOptions {
      return this.options.map((option) => ({ value: option.key, label: option.label }));
    },
  },
});
</script>
